import "./style.scss";

import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { Text } from "@amzn/stencil-react-components/text";
import { TrafficFrom } from "common/helpers/traffic-from";
import { useSearchExperience } from "hooks";
import React, { FC, useEffect } from "react";

import { CatalogicalRequestContent } from "../../types/catalogical-type";
import { CatalogItemCard } from "../CatalogItemCard";

export interface SearchExperienceRecommendedItemsProps {
  pageSize: number;
  categoryToFilterBy: string;
  children?: React.ReactNode;
  totalItems: number;
  perRow: number;
  tagToFilterBy?: string;
}

const SEND_METRICS = true;
const DEFAULT_ITEMS_PER_ROW = 3;
const GRID_GAP_VALUE = 39;
const ROW_GAP_VALUE = "40px";

const SearchExperienceRecommendedItems: FC<SearchExperienceRecommendedItemsProps> = ({
  categoryToFilterBy,
  pageSize,
  children,
  totalItems,
  perRow,
  tagToFilterBy,
}) => {
  const { items, searchCatalogItems, isLoading } = useSearchExperience();
  const itemsPerRow = perRow < 1 ? DEFAULT_ITEMS_PER_ROW : perRow;

  const searchRequest: CatalogicalRequestContent = {
    limit: totalItems,
    semanticSearch: "tools for communication",
    useSemanticSearch: false,
    itemType: "software",
    searchQuery: "tools for communication",
  };

  useEffect(() => {
    searchCatalogItems(searchRequest, SEND_METRICS);
  }, [categoryToFilterBy, pageSize]);

  if (items && items.length > 0) {
    return (
      <View>
        <Row
          id="recommended-items"
          display="flex"
          flexWrap="wrap"
          justifyContent="space-between"
          key={`${tagToFilterBy ?? "recommendations"}`}
          gridGap={`${GRID_GAP_VALUE}px`}
          rowGap={`${ROW_GAP_VALUE}px`}
        >
          {items.map((item, i) => (
            <Col
              key={i}
              style={{
                flex: `0 0 calc(${100 / itemsPerRow}% - ${GRID_GAP_VALUE}px)`,
                justifyContent: "start",
              }}
              data-cy={`recommended-item-${tagToFilterBy ?? "recommendations"}`}
            >
              <CatalogItemCard
                from={TrafficFrom.Recommended}
                name={item.name}
                shortDescription={item.shortDescription}
                logoUrl={item.logoUrl}
                taxonomyId={item.taxonomyId}
              />
            </Col>
          ))}
        </Row>
        {children}
      </View>
    );
  } else if (isLoading) {
    return (
      <View alignItems="center">
        <Spinner size={SpinnerSize.Small} />
      </View>
    );
  } else {
    return <Text dataTestId="recommended-items-no-results">No recommendations found</Text>;
  }
};

export default SearchExperienceRecommendedItems;
